import {
  createContext, useContext, useMemo, useState,
} from 'react';
import { AvailabilitiesPayload } from 'src/helpers/types';

type Props = {
  children: React.ReactNode;
};

export type ResidentDataType = {
  resident_availability: AvailabilitiesPayload[],
  timezone: string,
  is_editable: boolean,
  logo_uri: string
};
interface ResidentAvailabilitiesContextType {
  submittedAvailabilities: ResidentDataType ;
  setSubmittedAvailabilities: React.Dispatch<React.SetStateAction<ResidentDataType>>
}

const residentAvailabilitiesContext = createContext({} as ResidentAvailabilitiesContextType);

export const ResidentAvailabilitiesContextProvider = ({ children }: Props) => {
  const [submittedAvailabilities, setSubmittedAvailabilities] = useState({} as ResidentDataType);

  const value = useMemo(() => ({
    submittedAvailabilities,
    setSubmittedAvailabilities,
  }), [submittedAvailabilities, setSubmittedAvailabilities]);

  return (
    <residentAvailabilitiesContext.Provider value={value}>
      {children}
    </residentAvailabilitiesContext.Provider>
  );
};

export const useResidentAvailabilitiesContext = () => useContext(residentAvailabilitiesContext);
